import { unsafeCSS, html } from "lit";
import { BaseValueProps } from "../../base/value-props/value-props.js";
const styles = "";
const _CHCValueProps = class _CHCValueProps extends BaseValueProps {
  render() {
    return html`<div class="chc-c-value-props">${super.render()}</div>`;
  }
};
_CHCValueProps.styles = unsafeCSS([BaseValueProps.styles, styles]);
let CHCValueProps = _CHCValueProps;
export {
  CHCValueProps
};
//# sourceMappingURL=value-props.component.js.map
